import { Link } from "./api";

export class InnloggingError extends Error {
  statusCode: number;
  apiError: string;
  apiErrorMessage?: string;
  link?: Link[];

  constructor(
    message: string,
    statusCode: number,
    apiError: string,
    apiErrorMessage?: string,
    link?: Link[],
  ) {
    super(message);
    this.statusCode = statusCode;
    this.apiError = apiError;
    this.apiErrorMessage = apiErrorMessage;
    this.link = link;
  }
}

export class EntrypointLoadError extends InnloggingError {
  constructor(innloggingError: InnloggingError) {
    super(
      innloggingError.message,
      innloggingError.statusCode,
      innloggingError.apiError,
      innloggingError.apiErrorMessage,
      innloggingError.link,
    );
  }
}
